import axios from "axios";

const apiURL = process.env.REACT_APP_API_ENDPOINT;

/*Change Post Api here*/
const postApiAutoaddprojectPublic = async (data) => {
  return await axios.post(`${apiURL}/dapp-providers/public/create`, data);
};

const postCheckLiquidity = async (data) => {
  return await axios.post(`${apiURL}/publics/checking-liquidity`, data);
};

const postCheckGameCode = async (data) => {
  return await axios.post(
    `${apiURL}/dapp-providers/public/check-game-code
      `,
    data
  );
};

export { postApiAutoaddprojectPublic, postCheckLiquidity, postCheckGameCode };
